import { createSelector } from 'reselect'

const defaultResults = []

export const selectIsFunderGiftDataLoading = ({ funderGiftHistory: { isLoading } }) => isLoading
export const selectIsFunderPaginatedGiftDataLoading =
  pageNumber =>
  ({ funderGiftHistory: { isPaginatedLoading } }) => {
    return isPaginatedLoading[pageNumber]
  }

const selectFunderPaginatedGiftHistoryPageSelector = createSelector(
  [({ funderGiftHistory }) => funderGiftHistory, (_, pageNumber) => pageNumber],
  (funderGiftHistory, pageNumber) => ({
    paginatedResults:
      funderGiftHistory.paginatedResults[pageNumber] === undefined
        ? defaultResults
        : funderGiftHistory.paginatedResults[pageNumber].map(item => {
            const region =
              (item.charity &&
                Array.isArray(item.charity.charityRegions) &&
                item.charity.charityRegions.length &&
                item.charity.charityRegions[0].name) ||
              ''

            return { ...item, region }
          }),
    totalCount: funderGiftHistory.paginatedTotalCount
  })
)

export const selectFunderPaginatedGiftHistoryPage = pageNumber => state =>
  selectFunderPaginatedGiftHistoryPageSelector(state, pageNumber)
